import React from 'react';
import { Box } from '@mui/material';
import { Navigate, Outlet } from 'react-router-dom';
import { createStyleSheet, getToken } from 'utils/helpers';
import { colors } from 'common/constants';
const AuthLayout: React.FC = () => {
    const token = getToken();
    if (token) {
        return <Navigate to="/" />;
    }
    return (
        <Box sx={styles.rootAuth}>
            <Box sx={styles.content}>
                <Outlet />
            </Box>
        </Box>
    );
};

const styles = createStyleSheet({
    rootAuth: {
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: colors.backgroundColor,
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export default AuthLayout;
